'use client';
import React, { useState, Suspense } from 'react';
import SignUpLoginContent from './sign-up-login-screen/components/SignUpLoginContent';

function HomeWrapper() {
  const [lang, setLang] = useState<'vi' | 'en'>('vi');
  const [darkMode, setDarkMode] = useState(false);

  return (
    <div className={darkMode ? 'dark' : ''}>
      <SignUpLoginContent
        lang={lang}
        onLangChange={setLang}
        darkMode={darkMode}
        onDarkModeChange={setDarkMode}
      />
    </div>
  );
}

export default function HomePage() {
  return (
    <Suspense fallback={<div className="min-h-screen bg-background" />}>
      <HomeWrapper />
    </Suspense>
  );
}